import script from "./KPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./KPagination.vue?vue&type=script&setup=true&lang=ts"

import "./KPagination.vue?vue&type=style&index=0&id=3017e98f&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3017e98f"]])

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPagination});
